<div *ngIf="currentUser; else loggedOut">
  <div class="flex flex-col">
    <div>
      <h2 class="text-5xl m-10">
        <strong>{{ currentUser.username }}'s</strong> {{ 'profile' | translate }}
      </h2>
    </div>
    <div class="bg-white p-10 grow">
      <strong>{{ 'email' | translate }}:</strong>
      <br />
      {{ currentUser.email }}
      <br />
      <br />
      <strong>{{ 'roles' | translate }}:</strong>
      <ul>
        <li *ngFor="let role of currentUser.roles">
          {{ role.name }}
        </li>
      </ul>

      <div class="pt-10">
        <div class="font-bold mb-5">{{ 'change_password' | translate }}</div>
        <mat-form-field class="w-full">
          <mat-label>{{ 'old_password' | translate }}</mat-label>
          <input matInput [(ngModel)]="oldPassword" type="password" />
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>{{ 'new_password' | translate }}({{ 'min_length' | translate }} 6)</mat-label>
          <input matInput [(ngModel)]="newPassword" type="password" />
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>{{ 'confirm_new_password' | translate }}</mat-label>
          <input matInput [(ngModel)]="confirmPassword" type="password" />
        </mat-form-field>
        <br />
        <button mat-raised-button
                [disabled]="!newPassword || !oldPassword || (newPassword !== confirmPassword) || newPassword.length < 6 || loading"
                (click)="changePassword()">
          <div *ngIf="loading"
               class="border-gray-300 h-5 w-5 animate-spin rounded-full border-2 border-t-black"></div>
          <span *ngIf="!loading">{{ 'change_password' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #loggedOut>
  {{ 'please_login' | translate }}
</ng-template>
